import {flow, identity, isEmpty, negate, pickBy} from '@yandex-delivery/utils'

export const dropEmptyValues: <T extends object | undefined>(value: T) => T = pickBy(flow(identity, negate(isEmpty)))
